import { Tooltip } from '@material-ui/core';
import ActionButton, { MENU_BUTTON_CATEGORY } from 'src/components/UI/ActionButton';
import PauseIcon from '@material-ui/icons/Pause';
import PlayArrowIcon from '@material-ui/icons/PlayArrow';
import { useSelector } from 'react-redux';
import { Store, useAppDispatch } from 'src/redux/Store';
import { ButtonProps } from '@material-ui/core/Button/Button';
import { t } from 'src/lib/language';
import { openDialog } from 'src/redux/actions/dialogActions';
import { DIALOGS } from 'src/models/DialogModel';

interface OwnProps {
  recurringId: number,
  isActive: boolean,
}

type Props = OwnProps & ButtonProps;

const StopResumeRecurringButton = (props: Props) => {
  const { disabled, recurringId, isActive } = props;
  const dispatch = useAppDispatch();
  const lang = useSelector((state: Store) => state.language.language);

  const handleOpen = () => {
    dispatch(openDialog({
      dialog: DIALOGS.stopResumeRecurring,
      payload: { recurringId, active: !isActive },
    }));
  };

  return (
    <Tooltip
      title={t(lang, isActive ? 'menus.stop_subscription' : 'menus.resume_subscription')}
      placement="top-start">
      <span>
        <ActionButton
          variant="outlined"
          category={MENU_BUTTON_CATEGORY.action}
          onClick={handleOpen}
          disabled={disabled}>
          { isActive ? <PauseIcon /> : <PlayArrowIcon /> }
        </ActionButton>
      </span>
    </Tooltip>
  );
};

export default StopResumeRecurringButton;
